/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Outline_Color_AriaInputs */



/**
* | output |
* | --- |
* | "Outline Color" |
*
* @param {Video_Export_Outline_Color_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_outline_color_aria = /** @type {((inputs?: Video_Export_Outline_Color_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Outline_Color_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur du contour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konturfarbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore del contorno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет контура")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color del contorno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轮廓颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アウトラインの色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रूपरेखा का रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor do contorno")
	return /** @type {LocalizedString} */ ("Outline Color")
});